import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import FormInput from '../common/FormInput';
import { INDUSTRIES, EMPLOYMENT_POSITIONS } from '../../utils/profileConstants';

const EmploymentForm = ({
  employmentDetails = {},
  onEmploymentDetailsChange,
  errors = {}
}) => {
  const handleChange = (field, value) => {
    onEmploymentDetailsChange({
      ...employmentDetails,
      [field]: value
    });
  };

  return (
    <View style={styles.container}>
      <FormInput
        label="Company Name"
        value={employmentDetails.companyName || ''}
        onChangeText={(value) => handleChange('companyName', value)}
        error={errors.companyName}
        placeholder="Enter your company name"
      />

      <View style={styles.pickerField}>
        <Text style={styles.label}>Industry</Text>
        <View style={styles.pickerWrapper}>
          <Picker
            selectedValue={employmentDetails.industry || ''}
            onValueChange={(value) => handleChange('industry', value)}
            style={styles.picker}
            mode="dropdown"
          >
            <Picker.Item label="Select Industry" value="" />
            {INDUSTRIES.map((industry) => (
              <Picker.Item key={industry} label={industry} value={industry} />
            ))}
          </Picker>
        </View>
      </View>

      <View style={styles.pickerField}>
        <Text style={styles.label}>Position Level</Text>
        <View style={styles.pickerWrapper}>
          <Picker
            selectedValue={employmentDetails.position || ''}
            onValueChange={(value) => handleChange('position', value)}
            style={styles.picker}
            mode="dropdown"
          >
            <Picker.Item label="Select Position Level" value="" />
            {EMPLOYMENT_POSITIONS.map((position) => (
              <Picker.Item key={position} label={position} value={position} />
            ))}
          </Picker>
        </View>
      </View>

      <FormInput
        label="Job Title"
        value={employmentDetails.jobTitle || ''}
        onChangeText={(value) => handleChange('jobTitle', value)}
        error={errors.jobTitle}
        placeholder="Enter your specific job title"
      />

      <FormInput
        label="Job Description"
        value={employmentDetails.description || ''}
        onChangeText={(value) => handleChange('description', value)}
        error={errors.description}
        placeholder="Brief description of your role"
        multiline
        numberOfLines={3}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 4,
    width: '100%',
  },
  pickerField: {
    marginBottom: 12,
  },
  label: {
    fontSize: 12,
    marginBottom: 6,
    color: '#64748B',
    fontWeight: '600',
    marginLeft: 2,
  },
  pickerWrapper: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1.2,
    borderColor: '#EDF2F7',
    borderRadius: 10,
    overflow: 'hidden',
  },
  picker: {
    height: 44,
    width: '100%',
    color: '#1E293B',
  }
});

export default EmploymentForm;
